<div class="d-flex flex-row justify-content-between gap-2">
    <div class="data d-flex align-items-center">{{data}}</div>
    <div class="dismiss d-flex align-items-center text-center">
      <mat-icon (click)="snackBarRef.dismiss()">close</mat-icon>
    </div>
  </div>